import { UseQueryResult, useQuery } from 'react-query';

import socialWallService from '../../core/services/social-wall.service';
import { MINUTE } from '../../utils/timeUtils';

type UnreadCountResponse = {
  unreadCount: number;
};

const REFRESH_INTERVAL = 2 * MINUTE;

export const useSocialWallUnreadCount = (): UseQueryResult<UnreadCountResponse, Error> => {
  return useQuery(['unread-posts-count'], () => socialWallService.getUnreadPostsCount(), {
    refetchOnWindowFocus: true,
    refetchInterval: REFRESH_INTERVAL,
    staleTime: REFRESH_INTERVAL / 2,
  });
};
